import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { LOGO_URL } from "../config";

export const Footer = () => (
  <footer className="footer">
    <div className="max-w-7xl mx-auto px-4">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <img src={LOGO_URL} alt="Carepoint Health Supplies" className="h-20 md:h-24 mb-4 w-auto" loading="lazy" decoding="async" />
          <p className="text-sm text-gray-300">Your trusted supplier of medical, dental, care supplies and printer cartridges.</p>
        </div>
        <div>
          <h4 className="font-semibold mb-4">Shop By Category</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/products">All Products</Link></li>
            <li><Link to="/products?category=Ink%20Cartridges">Ink Cartridges</Link></li>
            <li><Link to="/products?category=Toner%20Cartridges">Toner Cartridges</Link></li>
            <li><Link to="/products?category=Printer%20Drums">Printer Drums</Link></li>
            <li><Link to="/products?category=First%20Aid">First Aid</Link></li>
            <li><Link to="/products?category=Gloves%20%26%20PPE">Gloves &amp; PPE</Link></li>
            <li><Link to="/products?category=Dental%20Supplies">Dental Supplies</Link></li>
            <li><Link to="/products?category=Vet%20Supplies">Vet Supplies</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-4">Customer Service</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" data-testid="footer-about-link">About Us</Link></li>
            <li><Link to="/account">My Account</Link></li>
            <li><Link to="/cart">Shopping Cart</Link></li>
            <li><Link to="/about#contact-card">Contact Us</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-4">Contact</h4>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2"><Phone className="w-4 h-4" /> 020 3633 8047</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4" /> orders@carepointuk.net</li>
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5" /> 128 City Road<br />London EC1V 2NX<br />United Kingdom</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-gray-500 mt-8 pt-8 text-center text-sm text-gray-300">
        <p>&copy; {new Date().getFullYear()} Carepoint Health Supplies. All rights reserved.</p>
      </div>
    </div>
  </footer>
);
